export default "__VITE_ASSET__X3Par0JD__"